/* eslint-disable no-mixed-operators */
import { toCents, correctPrice } from '@/utils/helpers';

export default class Contract {

  constructor(params) {
    const getters = [
      'hasLastTradePrice',
      'lastTradePriceAsCents',
      'lastClosePriceAsCents',
      'changePriceAsCents',
      'userAveragePricePerShareAsCents',
      'userChangePriceAsCents',
      'buyYesCostAsCents',
      'buyNoCostAsCents',
      'sellYesCostAsCents',
      'sellNoCostAsCents',
      'userOpenOrders',
      'totalSharesTradedDisplay',
      'mode',
      'lastTradePriceAsCentsWithZeroBypass',
      'investmentSizeAsCents',
    ];
    Object.keys(params).forEach((key) => {
      if (getters.indexOf(key) < 0) { // to avoid setter exception
        this[key] = params[key];
      }
    });
  }

  get hasLastTradePrice() {
    return this.lastTradePriceAsCents > 0;
  }

  get lastTradePriceAsCents() {
    const value = toCents(this.lastTradePrice);
    return Number.isFinite(value) ? value : 0;
  }

  get lastTradePriceAsCentsWithZeroBypass() {
    return this.hasLastTradePrice ? this.lastTradePriceAsCents : 0;
  }

  get lastClosePriceAsCents() {
    const value = toCents(this.lastClosePrice);
    return Number.isFinite(value) ? value : 0;
  }

  get changePriceAsCents() {
    if (!this.hasLastTradePrice) {
      return 0;
    }

    return this.lastTradePriceAsCents - this.lastClosePriceAsCents;
  }

  get userAveragePricePerShareAsCents() {
    const value = toCents(this.userAveragePricePerShare);
    return Number.isFinite(value) ? value : 0;
  }

  get userChangePriceAsCents() {
    if (!this.hasLastTradePrice) {
      return 0;
    }

    const roundedAverage = Math.round(this.userAveragePricePerShare * 100) / 100;
    if (this.mode === 'no') {
      return toCents(1 - this.lastTradePrice - roundedAverage);
    }
    return toCents(this.lastTradePrice - roundedAverage);
  }

  get buyYesCostAsCents() {
    return correctPrice(toCents(this.bestYesPrice || this.bestYesCost));
  }

  get buyNoCostAsCents() {
    return correctPrice(toCents(this.bestNoPrice || this.bestNoCost));
  }

  get sellYesCostAsCents() {
    return correctPrice(100 - this.buyNoCostAsCents);
  }

  get sellNoCostAsCents() {
    return correctPrice(100 - this.buyYesCostAsCents);
  }

  get userOpenOrders() {
    return this.userOpenOrdersBuyQuantity + this.userOpenOrdersSellQuantity;
  }

  get mode() {
    if (this.userQuantity === 0 && this.userOpenOrders === 0) return '';
    if (this.userPrediction === 0) return 'no';
    if (this.userPrediction === 1) return 'yes';
    return '';
  }

  get totalSharesTradedNumber() {
    return this.totalSharesTraded || this.totalTrades || 0;
  }

  get totalSharesTradedDisplay() {
    const value = this.totalSharesTradedNumber;
    return value.toLocaleString();
  }

  get investmentSizeAsCents() {
    return this.lastTradePriceAsCents * this.totalSharesTradedNumber;
  }

}



// WEBPACK FOOTER //
// ./src/models/contract.js